import { createAsyncTypes } from 'utils/ActionCreator'

const ATO_OVERVIEW_LOCATION = 'Dashboard/AtoOverview'

export const FETCH_ATO_OVERVIEW_ASYNC = createAsyncTypes(
  'FETCH_ATO_OVERVIEW',
  ATO_OVERVIEW_LOCATION
)

export const TIMEFRAME_CHANGE = `${ATO_OVERVIEW_LOCATION}/TIMEFRAME_CHANGE`
export const CUSTOM_RANGE_CHANGE = `${ATO_OVERVIEW_LOCATION}/CUSTOM_RANGE_CHANGE`

// The Dashboard redux slice is injected per route, so leaving the page drops
// the picked timeframe. Router history state survives that and Back, the same
// way the Threat Protection list keeps its filters.
export const NAME_FOR_HISTORY_STORE = ATO_OVERVIEW_LOCATION

// Only these two 403 codes tell the tenant something they can act on.
export const BLOCKED_CODES = ['ato_not_licensed', 'ato_integration_missing']
